


import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Box, Breadcrumbs, Button, Divider, Grid, Link, ListItemIcon, Menu, MenuItem, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Theme, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { getProductImage, Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import { getAllCatalogsAction, getCatlogsAction, getControlsAction, getOptionControlsAction, getProductSelectionCgIDAction, getProductSelectionRobotAction, getRobotLocalesAction, useModelOptions } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import { DeviceType, WebSiteContext } from '../orbit-context';
import ZTree from './component/zTree';
import './selections.css'
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
import { TabPanel } from '../components';
import { IvymobiTabs } from '../components/IvymobiTabs';
import SelectionItem from './component/selectionItem';
import _ from 'lodash';
import { el } from 'date-fns/locale';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import ControlPanel from './component/controlPanel';
import OptionControlPanel from './component/optionControlPanel';
import { stringify } from 'query-string';
import copy from 'copy-to-clipboard';
import { resolveUrl } from '../api';
import { modelOptionsAction, useOptions, getProductSelectionListAction } from '@ivymobi/orbit-core/business/user';
import { createStyles, makeStyles, withStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)  },


}));
const IDivider = withStyles((theme: Theme) =>
  createStyles({
    vertical:{
      width:'2px'
    }
  }),
)(Divider);
 const CustomTabs = withStyles((theme: Theme) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      display:'none',
      maxWidth: 36,
      width: '100%',
      backgroundColor: '#2a74eb',
    },
  },
  flexContainer:{
    alignItems:'center',
    padding:'7px'
  }

}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const RobotSelectionsListView = (props) => {
  const { base64Info } = useParams<any>()??{base64Info:null};
  const deviceType = useContext(DeviceType);

  const classes = useStyles();
  const history = useHistory();
  const modeOptions = useOptions();
  const  {robot,robotOptions,control,controlOptions} = modeOptions
  const {webInfo,language,getUnit} = useContext(WebSiteContext);
  const dispatch = useDispatch(); 
  const postModelOptions = (options)=>{
    dispatch(modelOptionsAction({user:{id:'options'}, tenant:{id:webInfo?.tnt_id}, options}));
  }
  const getCgId =(infos,cgName)=>{
    for(let i=0;i<infos?.length;i++){
      if(infos[i].cgName?.zh===cgName){
        
        return infos[i].cgId;
      }
     
    }
    return ''
  }
  useEffect(()=>{
    props.setTitle('选型清单')
    props.setParents([{ to:'/robot',name:'机器人'}])
  },[])
  useEffect(()=>{
    dispatch(getProductSelectionCgIDAction({user:{token:null,user:null}, tenant:{id:webInfo?.tnt_id}})).then(
      (infos) => { 
        dispatch(getProductSelectionListAction({tenantId:webInfo?.tnt_id,base64:base64Info})).then((res)=>{
          for(let m=0;m<res.length;m++){
            res[m].productsData = res[m].productData;
          for(let i=0;i<res[m].productData.length;i++){
            let featuresDic = {};
            let product = res[m].productData[i];
            
            const csName = _.get(product,'feature[0].referenceFeatureSystemName')
            const features =  _.get(product,'feature[0].features')
            for(let index=0;index<features.length;index++){
              featuresDic[features[index].frIdref]  ={ftype:features[index].fvalueIdref?'ref':'value', frIdref:features[index].frIdref,fvalue:features[index].fvalueIdref?features[index].fvalueIdref:features[index].fvalue,fvalueName:language[csName].fValues[features[index].fvalueIdref], fIdName:language[csName].features[features[index].frIdref]}
            }
            product.featuresDic = featuresDic;
          }
          }  
          let robot = null;
      let control=null;
      let robotId = null;
      let controlCataId=null;
      let controlId = null;
      let robotOptions = null;
      let robotOptionId= null;
      let controlOptions = null;
      let controlOptionId =null;
          
      for(let i=0;i<res.length;i++){
        console.log("&&&&&&&&&&&&&&&&",res[i],getCgId(infos,'机器人'))
        if(res[i].cgId===getCgId(infos,'机器人')){
          robot = res[i].productData[0];
          robotId = res[i].id;
        }else if(res[i].cgId===getCgId(infos,'控制器')){
          control = res[i].productData[0];
          controlCataId = res[i].id;
        }else if(res[i].cgId===getCgId(infos,'机器人选件')){
          robotOptions = res[i].productData;
          robotOptionId= res[i].id;
        }else if(res[i].cgId===getCgId(infos,'控制器选件')){
          controlOptions = res[i].productData;
          controlOptionId= res[i].id;
        }
    }
    postModelOptions({...modeOptions,robot,control,robotOptions,controlOptions,robotId,controlId,controlCataId,robotOptionId,controlOptionId})
    
        })
      })
  },[webInfo])
  return (
    <div style={{height:deviceType==='computer'?'calc(100% - 30px)':'100%'}}>
      {deviceType==='computer'&&<Breadcrumbs style={{height:'30px'}} separator=">" maxItems={8}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/robot'}
          component={RouteLink}
        >
          机器人
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/robot/selections'}
          component={RouteLink}
        >
          产品选型
        </Link>
        <Typography color="textPrimary">
          选型清单
        </Typography>
      </Breadcrumbs>}
      <Box className={classes.pages}>
        <Box style={{width:deviceType==='computer'?'80%':'100%',paddingTop:'18px',paddingBottom:'16px',height:'100%',display:'flex',flexDirection:'column'}}> 
          <Box style={{display:'flex',justifyContent:deviceType==='computer'?'space-between':'end'}}>
            {deviceType==='computer'&&<Title name={'选型清单'}></Title>}
           <Box style={{display:'flex',flexDirection:'row'}}>
            <Button variant='contained' color='primary' style={{background:'red',fontSize:'15px'}} onClick={()=>{
               // 
               console.log("model-===",modeOptions)
               let info = {};
                if(modeOptions.robot)
                  info[modeOptions.robotId] = modeOptions.robot.id;
                if(modeOptions.control)
                 info[modeOptions.controlCataId] = modeOptions.control.id;
                if(modeOptions.robotOptions){ 
                  let ops = [];
                  for(let i=0;i<modeOptions.robotOptions.length;i++){
                    ops.push(modeOptions.robotOptions[i].id)
                  }
                  info[modeOptions.robotOptionId] = ops; 
                }
                if(modeOptions.controlOptions){
                  let ops = [];
                  for(let i=0;i<modeOptions.controlOptions.length;i++){
                    ops.push(modeOptions.controlOptions[i].id)
                  }
                  info[modeOptions.controlOptionId] = ops;

                }
                console.log("*******************",info)
                copy(resolveUrl(`/robot/selectList/${btoa(JSON.stringify(info))}`));
                              alert('复制成功'); 
            }}
                                > 复制链接
            </Button>
           </Box>
          </Box> 
          <Box style={{flexGrow:'1',height:'0px',background:'white',overflow:'auto',marginTop:'12px'}}>
          {robot&&<Box style={{width:'100%',background:'white',padding:'20px'}}>
            <Typography variant='h5'  color="textPrimary">
              机器人
            </Typography>
            <Box>
            <Box style={{border: '1px solid #e3e3e3' }}>
            <TableContainer component={Paper}>

            <Table style={{width:deviceType==='mobile'?'1024px':'unset' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{backgroundColor:'white'}}>机器人</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">型号</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">{`最大可搬运重量(${getUnit('IF000004')})`}</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">{`臂长(${getUnit('IF000005')})`}</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">{`上下行程(${getUnit('IF000006')})`}</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">使用环境</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">图片</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">操作</TableCell>
                </TableRow> 
              </TableHead>
              <TableBody>
              <TableCell component="th" scope="row">
                              {robot.featuresDic['IF000001']?.fvalueName}
                            </TableCell>
                            <TableCell align='center'>{_.get(robot,'details.descriptionShort.zh')}</TableCell>
                            <TableCell align="center">{robot.featuresDic['IF000004']?.fvalue+''}</TableCell>
                            <TableCell align="center">{robot.featuresDic['IF000005']?.fvalue+''}</TableCell>
                            <TableCell align="center">{robot.featuresDic['IF000006']?.fvalue+''}</TableCell>
                            <TableCell align="center">{robot.featuresDic['IF000007']?.fvalueName}</TableCell>
                            <TableCell align="center">
                              <img src={getProductImage(robot.mime)} style={{width:'25px',height:'25px'}}/>
                            </TableCell>
                            <TableCell align="center"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red',width:'150px'}}
                                onClick={()=>{
                                  postModelOptions({...modeOptions,robot:null,control:null,robotOptions:null,controlOptions:null})

                                  // setRobotSelect(row);
                                }}
                              >
                                删除
                              </Button></TableCell>
          
              </TableBody>
  
              </Table>
              </TableContainer>
            </Box>

            </Box>
          </Box>}
          {control&&<Box style={{width:'100%',background:'white',marginTop:'12px',padding:'20px'}}>
            <Box>
            <Box style={{border: '1px solid #e3e3e3' }}>
            <TableContainer component={Paper}>
            <Table style={{ }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{backgroundColor:'white'}}>控制器</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">型号</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">操作</TableCell>
                </TableRow> 
              </TableHead>
              <TableBody>
              <TableCell component="th" scope="row">
                          {_.get(control,'details.descriptionShort.zh')}
                            </TableCell>
                            <TableCell align='center'> {control.featuresDic['IF000002']?.fvalue}</TableCell>
           
                           <TableCell align="center"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red',width:'150px'}}
                                onClick={()=>{
                                  postModelOptions({...modeOptions,control:null,controlOptions:null})
                                  // setRobotSelect(row);
                                }}
                              >
                                删除
                              </Button></TableCell>
          
              </TableBody>
  
              </Table>
              </TableContainer>
            </Box>

            </Box>
          </Box>}
          {(robotOptions&&(robotOptions?.length>0))&&<Box style={{width:'100%',background:'white',marginTop:'12px',padding:'20px'}}>
            <Box>
            <Box style={{border: '1px solid #e3e3e3' }}>
            <TableContainer component={Paper}>
            <Table style={{width:deviceType==='mobile'?'1024px':'unset' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{backgroundColor:'white'}}>机器人选件</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">名称</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">型号</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">规格</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">图片</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">操作</TableCell>

                </TableRow> 
              </TableHead>
              <TableBody>
                {robotOptions.map(row=>{
                  return (<TableRow>
                    <TableCell component="th" scope="row">主体选件</TableCell>
                                  
                    <TableCell align='center'>{_.get(row,'details.descriptionShort.zh')}</TableCell>
                    <TableCell align='center'> {row.featuresDic['IF000002']?.fvalue}</TableCell>
                    <TableCell align='center'>{row.featuresDic['IF000015']?.fvalue}</TableCell>
                    <TableCell align="center">
                      <img src={getProductImage(row?.mime)} style={{width:'25px',height:'25px'}}/>
                    </TableCell>
                    <TableCell align="center"><Button variant='contained'  style={{ background:'#ece8e8',color:'red',width:'150px'}}
                      onClick={()=>{
                                        postModelOptions({...modeOptions,robotOptions:_.remove(robotOptions,function(x){ 
                                          return x.id !== row.id
                                  })})
                                        // setRobotSelect(row);
                                      }} >删除 </Button>
                    </TableCell>
                  </TableRow> )
                })}
                              
              </TableBody>
  
              </Table>
              </TableContainer>
            </Box>

            </Box>
          </Box>}
          {(controlOptions&&controlOptions?.length>0)&&<Box style={{width:'100%',background:'white',marginTop:'12px',padding:'20px'}}>
            <Box>
            <Box style={{border: '1px solid #e3e3e3',paddingLeft:'30px',paddingRight:'30px',paddingTop:'20px'}}>
            <Table style={{width:deviceType==='mobile'?'1024px':'unset',marginBottom:'-1px'}}>
              <TableHead>
                <TableRow>
                  <TableCell style={{backgroundColor:'white'}}>控制器选件</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">名称</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">型号</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">规格</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">图片</TableCell>
                    <TableCell style={{backgroundColor:'white'}} align="center">操作</TableCell>

                </TableRow> 
              </TableHead>
              <TableBody>
                {controlOptions.map(row=>{
                  return (<TableRow>
                    <TableCell component="th" scope="row">控制器选件</TableCell>
                                  
                    <TableCell align='center'>{_.get(row,'details.descriptionShort.zh')}</TableCell>
                    <TableCell align='center'> {row.featuresDic['IF000002']?.fvalue}</TableCell>
                    <TableCell align='center'>{row.featuresDic['IF000015']?.fvalue}</TableCell>
                    <TableCell align="center">
                      <img src={getProductImage(row?.mime)} style={{width:'25px',height:'25px'}}/>
                    </TableCell>
                    <TableCell align="center"><Button variant='contained'  style={{ background:'#ece8e8',color:'red',width:'150px'}}
                      onClick={()=>{
                          postModelOptions({...modeOptions,controlOptions:_.remove(controlOptions,function(x){ 
                            return x.id !== row.id
                    })})                                        // setRobotSelect(row);
                                      }} >删除 </Button>
                    </TableCell>
                  </TableRow> )
                })}
                              
              </TableBody>
  
              </Table>
            </Box>

            </Box>
          </Box>}
          </Box>

        </Box>
        
        

      </Box>
    </div>
  );
};

export default function RobotSelectionsListContainer (props) {
  const dispatch = useDispatch();


  return (
    <RobotSelectionsListView {...props}

    />
  );
}